import React from 'react';
import { Fragment } from 'react';
import Footer from '../../../components/footer';
import Head from '../../../components/head';
import Header from '../../../components/headerrh';
import Holerite from '../../../components/rh/holerites/cadastrar';


function CadHoleriteScreen () {
    return (
        <Fragment>
            <Head titulo="Cadastro de Holerite | Consórcio LVF" />
            <Header />
            <Holerite />
            <Footer />
        </Fragment>
    );
}

export default CadHoleriteScreen;